export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  return validPassword
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?$/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

export const validatorPath = val => {
  if (val === undefined || val === null) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^\/(([A-z0-9\-\%]+\/)*[A-z0-9\-\%])*?(\?([\w-]+(=[\w-]*)?(&[\w-]+(=[\w-]*)?)*)?)*?$/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

export const validatorIp = ip => {
  const re = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]*[a-zA-Z0-9])\.)+([A-Za-z]|[A-Za-z][A-Za-z0-9\\-]*[A-Za-z0-9])$/
  return re.test(ip)
}

// HTTP CODE VALIDATOR - UP TO 999 becasuse of third parties
export const httpCodeValidator = number => {
  const re = /^(100|[1-9]\d{2})$/
  return re.test(number)
}

export const validatorUrlOrIp = val => {
  const reIp = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]*[a-zA-Z0-9])\.)+([A-Za-z]|[A-Za-z][A-Za-z0-9\\-]*[A-Za-z0-9])$/

  /* eslint-disable no-useless-escape */
  const reUrl = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */

  return reIp.test(val) || reUrl.test(val)
}

export const validatorWildcard = wildcard => {
  if (wildcard.charAt(0) === '*' && wildcard.charAt(1) === '.') {
    wildcard = wildcard.substring(2)
  }
  const re = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]*[a-zA-Z0-9])\.)+([A-Za-z]|[A-Za-z][A-Za-z0-9\\-]*[A-Za-z0-9])$/
  return re.test(wildcard)
}

export const validatorIpWithSubnet = val => {
  const regExp = /((?:\d{2,3}\.\d{2,3}\.\d{2,3}\.\d{2,3}\/\d{1,2})|\d{2,3}\.\d{2,3}\.\d{2,3}\.\d{2,3})/
  return regExp.test(val)
}

export const validatorIpOrSubnet = val => {
  const regExp = /^(\b25[0-5]|\b2[0-4][0-9]|\b[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  return regExp.test(val)
}

export const validatorRange = val => {
  const regExp = /^\d{0,5}(-\d{0,5})?$/
  if (regExp.test(val)) {
    const temp = val.split('-')
    const [value1, value2] = temp
    if (temp.length > 1) {
      return (
        Number(value1) < 65537
        && Number(value2) > Number(value1)
        && Number(value2) < 65537
      )
    }
    return Number(value1) < 65537
  }
  return regExp.test(val)
}

export const validatorIpSubnet = val => {
  const regExp = /^(?:\d{1,2}|1\d\d|2[0-4]\d|25[0-5])(?:\.(?:\d{1,2}|1\d\d|2[0-4]\d|25[0-5])){3}(\/(?:\d{1}|1\d|2\d|3[0-2]))?$/
  return regExp.test(val)
}

export const validatorForwardSlash = val => {
  // eslint-disable-next-line no-useless-escape
  const regExp = /^[a-zA-Z0-9\/\-\_]+$/gm
  return regExp.test(val)
}

export const validatiorPassword = val => {
  const regExp = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d\D\W]{7,}(\w|\d)$/
  return regExp.test(val)
}

export const validatorIntNumber = val => {
  if (val > 2147483647) {
    return false
  }
  const regExp = /(^\d{1,10}$)/
  return regExp.test(val)
}

export const validatorUri = val => {
  // eslint-disable-next-line no-useless-escape
  const regExpUrl = /^[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,5}\b(?::\d+)?(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?$/
  const regExpIp = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]*[a-zA-Z0-9])\.)+([A-Za-z]|[A-Za-z][A-Za-z0-9\\-]*[A-Za-z0-9])$/
  const regLocal = /(?:(^localhost[^<]*)|(^172\.[^<]*)|(10\.[^<]*)|(192\.[^<]*)|(127\.[^<]*))/

  return (regExpUrl.test(val) || regExpIp.test(val)) && !regLocal.test(val)
}

export const notLocalhostUrl = val => {
  const regLocal = /^(?:(^localhost[^<]*)|(^172\.[^<]*)|(10\.[^<]*)|(192\.[^<]*)|(127\.[^<]*))$/

  return !regLocal.test(val)
}

export const validatiorFileName = val => {
  const regExp = /^[\w\-. ]+$/
  return regExp.test(val)
}

export const folderNameValidator = val => {
  // eslint-disable-next-line no-control-regex
  const regExp = /^[^\s^\x00-\x1f\\?*:"";<>|\\/.][^\x00-\x1f\\?*:"";<>|\\/]*[^\s^\x00-\x1f\\?*:"";<>|\\/.]+$/
  return regExp.test(val)
}

export const sumValidator = (value, { value2, limit }) => {
  const sum1 = Number(value) + Number(value2)
  return sum1 <= limit
}
